// Interactive Tool

const indicator = document.querySelector('.pfd-finder__indicator');
const indItem = document.querySelectorAll('.pfd-finder__indicator-item');
const buttonGroups = document.querySelectorAll('.pfd-finder__col-full');
const buttonGroupWrap = document.querySelector('.pfd-finder__inner');

let primArray = [];
let secArray = [];
let buttonGroupHeight = 0;
const toolButtons = document.querySelectorAll('.pfd-finder__btn');
const pfdItems = document.querySelectorAll('.pfd-filter-item');
const pfdItemsRecom = document.querySelectorAll('.pfd-filter-item-recom');
const pfdItemsRecomAlso = document.querySelectorAll('.pfd-filter-item-recom-also');

const pfdParentBulk = document.querySelector('.pfd-finder__bulk');
const pfdParentRecom = document.querySelector('.pfd-finder__recommend');
const pfdParentRecomAlso = document.querySelector('.pfd-finder__recommend-also');
const delay = ms => new Promise(res => setTimeout(res, ms));

const pfdParentNoSelection = document.querySelector('.pfd-finder__nothingfound');
let breadcrumb = document.querySelector('.pfd-finder__breadcrumbs');

// Document Ready
window.addEventListener('load', function () {
	if (indicator) {
		indicator.classList.add('loaded');
		updateGroupHeights();
		hideHeader();
	}
  }, false);


// PFD finder slideshow
indItem.forEach(function(ind) {
	ind.addEventListener('click', function(indEvent) {
		indEvent.preventDefault();
		let indData = parseInt(ind.dataset.ind);

		showCurrentButtonGroup(indData);

		updateGroupHeights();
		updateIndStates();
	});
});

function updateIndStates() {
	console.log("clicked");
	if(buttonGroups.length){
		buttonGroups.forEach(function(group) {

			let buttonNum = group.dataset.group;

			if (group.classList.contains('active')) {
				indItem[buttonNum - 1].classList.add('active');
				console.log('button active' + buttonNum);
			} else {
				indItem[buttonNum - 1].classList.remove('active');
				console.log('button not active' + buttonNum);
			}

			if (group.querySelector('.selected')) {
				console.log("somethign is selected in this group?");
				indItem[buttonNum - 1].classList.add('selected');
			} else {
				indItem[buttonNum - 1].classList.remove('selected');
			}
		});
	}

	// console.log(indData);

	// indItem.forEach(function(item) {
	// 	item.classList.remove('active');
	// });

	// ind.classList.add('active');
}
const secondHeader = document.querySelector('.pfd-finder__logo');
const header = document.querySelector('#shopify-section-header');
const hideHeaderButton = document.querySelector('.pfd-finder__hideMenu');

// Hide header
function hideHeader() {
	let headerHeight = header.clientHeight * -1;
	header.style.transition = "all 0.3s";
	header.style.marginTop = headerHeight + "px";
	secondHeader.style.display = "block";
	hideHeaderButton.style.display = "none";
}

// Show header on logo click
if (secondHeader) {
	secondHeader.addEventListener('click', function(event) {
		event.preventDefault();
		showHeader();
	});
}

// Hide header on up button click
if (hideHeaderButton) {
	hideHeaderButton.addEventListener('click', function(event) {
		event.preventDefault();
		hideHeader();
	});
}

// Show header
function showHeader() {
	// let headerHeight = header.clientHeight * -1;
	header.style.transition = "all 0.3s";
	header.style.marginTop = "0px";
	secondHeader.style.display = "none";
	hideHeaderButton.style.display = "block";
}

// Get button group heights and set parent height
function updateGroupHeights() {
	buttonGroups.forEach(function(group) {
		if(group.classList.contains('active')) {
			buttonGroupHeight = group.clientHeight;
		}
		// if(buttonGroupHeight < group.clientHeight) {
		// 	buttonGroupHeight = group.clientHeight;
		// }
	});
	buttonGroupWrap.style.height = buttonGroupHeight + "px";
}

// Show current button group
function showCurrentButtonGroup(activeNum) {
	buttonGroups.forEach(function(group) {
		let groupData = group.dataset.group;
		// console.log("group: " + groupData + " activeNum: " + activeNum);
		if (groupData == activeNum) {
			group.classList.add('active');
		} else {
			group.classList.remove('active');
		}
	});
}

// On button click
toolButtons.forEach(function(item) {
  item.addEventListener('click', (e) => {
	e.preventDefault();
    primArray = [];
    secArray = [];
    hidePfds();
	// hideSubMenu();

	// Deselect all buttons in group
	let anySelected = false;
    let dataValue = item.dataset.sort;
	let allSameDataSort = document.querySelectorAll(`[data-sort="${dataValue}"]`);
    allSameDataSort.forEach(function(each) {
      if(each.dataset.nameid != item.dataset.nameid) {
        anySelected = true;
        each.classList.remove('selected');
      }
    });

	// Toggle currently selected button
    if (item.classList.contains('selected')) {
        anySelected = true;
        item.classList.remove('selected');

		// If button has been deselected remove all children buttons
		// let parentNum = item.parentElement.parentElement.dataset.group;
		// let buttonGroups = document.querySelectorAll('.pfd-finder__col-full');
		// if(buttonGroups.length){
		// 	buttonGroups.forEach(function(group) {
		// 		group.classList.add('test');
		// 		let groupNum = group.dataset.group;
		// 		if (parentNum < groupNum) {
		// 			group.classList.add('hide');
		// 			let groupSelected = group.querySelector('.selected');
		// 			if (groupSelected) {
		// 				groupSelected.classList.remove('selected');
		// 			}
		// 		}
		// 	});
		// }


    } else {
		item.classList.add('selected');
		// checkButtonDisabled(item);
    }


	let allSelectedButtons = document.querySelectorAll('.pfd-finder.selected');
	let buttonHighNum = 0;
	if(allSelectedButtons.length) {
		// Get Hightest button group #
		allSelectedButtons.forEach(function(button) {
			let num = button.parentElement.parentElement.dataset.group
			if( num > buttonHighNum) {
				buttonHighNum = num;
			}
		});

	}

	// Get button group number
	let buttonGroups = document.querySelectorAll('.pfd-finder__col-full');
	if(buttonGroups.length){
		buttonGroups.forEach(function(group) {
			let groupNum = group.dataset.group;
			// if (groupNum <= (parseInt(buttonHighNum) + 1)) {
			// 	group.classList.remove('hide');
			// } else {
			// 	group.classList.add('hide');
			// }
		});
	}



	// Show or hide pfds
    if (anySelected == false) {
      pfdItems.forEach(function(pfd) {

		  const slowShow = async () => {
			pfd.classList.remove('hidden');
			await delay(100);
			pfd.classList.add('show');
		  };
          slowShow();

      });
    } else {
      setupArrays();
    }

	checkButtonDisabled();
  });
});

if (breadcrumb) {
	initializeButtons();
}

// initialize buttons
function initializeButtons() {
	let breadcrumbButtons = breadcrumb.querySelectorAll('button');

	if(breadcrumbButtons.length) {
		breadcrumbButtons.forEach(function(button) {
			button.addEventListener('click', function(event) {
				event.preventDefault();
				let buttonName = parseInt(button.dataset.bread);
				showCurrentButtonGroup(buttonName);
				updateGroupHeights();
				updateIndStates();
			});
		});
	}
}

function clearButtons() {
	let breadcrumbButtons = breadcrumb.querySelectorAll('button');
	if(breadcrumbButtons.length) {
		breadcrumbButtons.forEach(function(button) {
			button.removeEventListener('click', function(event) {
			});
		});
	}
}


// Build out breadcrumbs
function buildBreadcrumbs(activity, age, weight, water) {
	clearButtons();
	let wrap = document.createElement("div");

	// Clear breadcrumb
	breadcrumb.innerHTML = "";
	if (activity !== '') {
		let para = document.createElement("button");
		para.innerText = activity;
		para.dataset.bread = '1';
		wrap.appendChild(para);
	}

	if (age !== '') {
		let para = document.createElement("button");
		para.innerText = age;
		para.dataset.bread = '2';
		wrap.appendChild(para);
	}

	if (weight !== '') {
		let para = document.createElement("button");
		para.innerText = weight;
		para.dataset.bread = '3';
		wrap.appendChild(para);
	}

	if (water !== '') {
		let para = document.createElement("button");
		para.innerText = water;
		para.dataset.bread = '4';
		wrap.appendChild(para);
	}
	breadcrumb.appendChild(wrap);
	initializeButtons();
}

// Check if there is supposed to be disabled buttons based on selection
function checkButtonDisabled(button) {
	let buttonAdultDisabled = false;
	let buttonSmallDisabled = false;
	let buttonMediumDisabled = false;
	let buttonAdult = document.querySelector('[data-nameid="16+ years"]');
	let buttonsmall = document.querySelector('[data-nameid="30-50 lbs"]');
	let buttonmedium = document.querySelector('[data-nameid="50-90 lbs"]');

	// if 16+ years is clicked disable small & medium
	if (buttonAdult.classList.contains('selected')) {

		buttonSmallDisabled = true;
		buttonMediumDisabled = true;
	} else {
		buttonsmall.disabled = false;
		buttonmedium.disabled = false;
	}

	if (buttonSmallDisabled == true) {
		buttonsmall.disabled = true;
	} else {
		buttonsmall.disabled = false;
	}

	if (buttonMediumDisabled == true) {
		buttonmedium.disabled = true;
	} else {
		buttonmedium.disabled = false;
	}
	// if small or medium is clicked disabled 16+ years
	if (buttonsmall.classList.contains('selected') || buttonmedium.classList.contains('selected')) {
		buttonAdultDisabled = true;
	}
	if (buttonAdultDisabled == true) {
		buttonAdult.disabled = true;
	} else {
		buttonAdult.disabled = false;
	}


}


// Hide menu on mobile
// function hideSubMenu() {
// 	let buttonGroups = document.querySelectorAll('.pfd-finder__col-full-buttons');
// 	buttonGroups.forEach(function(item) {
// 		item.classList.remove('active');
// 	});
// }

function setupArrays() {
  let typeActivity = false;
  let typeWater = false;
  let typeAge = false;
  let typeWeight = false;

  let breadActivity = '';
  let breadAge = '';
  let breadWeight = '';
  let breadWater = '';

  toolButtons.forEach(function(item) {
    if(item.classList.contains('selected')) {
    let textValue = item.dataset.nameid;
    let catValue = item.dataset.sort;

      if (catValue === "Activity") {
		breadActivity = textValue;
        typeActivity = textValue;
      }
      if (catValue === "Type of Water or Near Water Type") {
		  breadWater = textValue;
        typeWater = textValue;
      }
      if (catValue === "Age") {
		  breadAge = textValue;
        typeAge = textValue;
      }
      if (catValue === "Weight") {
		  breadWeight = textValue;
        typeWeight = textValue;
      }

    }
  });
  buildBreadcrumbs(breadActivity, breadAge, breadWeight, breadWater);
  getData(typeActivity, typeWater, typeAge, typeWeight);
}

function getData(passActivity, passWater, passAge, passWeight) {

  	for(var i = 0; i < toolDb.length; i++) {

      let passedTest = true;

      if(passActivity) {
        if( toolDb[i]["Activity"] != passActivity ) {
          passedTest = false;
        }
      }
      if(passWater) {
        if( toolDb[i]["Type of Water or Near Water Type"] != passWater ) {
          passedTest = false;
        }
      }
      if(passAge) {
        if( toolDb[i]["Age"] != passAge ) {
          passedTest = false;
        }
      }
      if(passWeight) {
        if( toolDb[i]["Weight"] != passWeight ) {
          passedTest = false;
        }
      }

      if( passedTest ) {
        primArray.push( toolDb[i]["Primary Choice"] );
        secArray.push( toolDb[i]["Secondary Choice"] );
      }
    }

	if(passActivity && passWater && passAge && passWeight) {
		showPfds(true);
	} else {
		showPfds(false);
	}


// displayAllPFDs();

}

function hidePfds() {

  pfdItems.forEach(function(item) {
    item.classList.add('hidden');
    item.classList.remove('show');
  });
  pfdItemsRecom.forEach(function(item) {
    item.classList.add('hidden');
    item.classList.remove('show');
  });
  pfdItemsRecomAlso.forEach(function(item) {
    item.classList.add('hidden');
    item.classList.remove('show');
  });

}

function displayAllPFDs() {
	pfdItems.forEach(function(pfd) {
		// console.log("Name: " + pfd.dataset.pfditem);
	});
}

function showPfds(recom) {

	if(recom == false) {
		pfdParentBulk.classList.add('show');
		pfdParentRecom.classList.remove('show');
		pfdParentRecomAlso.classList.remove('show');
		pfdParentNoSelection.classList.remove('show');
		for(var i = 0; i < primArray.length; i++ ) {
			var pfdItem = primArray[i];
			let showPrimProduct = pfdParentBulk.querySelector(`[data-pfditem="${pfdItem}"]`);
			if (showPrimProduct) {
				const slowShow = async () => {
					showPrimProduct.classList.remove('hidden');
					// await delay(1);
					// console.log("slow show");
					showPrimProduct.classList.add('show');
				  };
				  slowShow();
			}
		}
		for(var i = 0; i < secArray.length; i++ ) {
			var pfdItem = secArray[i];
			let showSecProduct = pfdParentBulk.querySelector(`[data-pfditem="${pfdItem}"]`);
			if (showSecProduct) {
				const slowShow = async () => {
					showSecProduct.classList.remove('hidden');
					// await delay(1);
					// console.log("show Sec Array products");
					// console.log("slow show");
					showSecProduct.classList.add('show');
				  };
				  slowShow();
			}
		}
	} else {
		// Final Recommended Selection
		pfdParentBulk.classList.remove('show');
		pfdParentNoSelection.classList.remove('show');
		pfdParentRecom.classList.remove('show');
		let nothingFound = true;
		// Primary PFD
		for(var i = 0; i < primArray.length; i++ ) {
			var pfdItem = primArray[i];
			let showPrimProduct = pfdParentRecom.querySelector(`[data-pfditem="${pfdItem}"]`);
			if (showPrimProduct) {
				showPrimProduct.classList.remove('hidden');
				showPrimProduct.classList.add('show');
				pfdParentRecom.classList.add('show');
				nothingFound = false;
			}
		}
		// Secondary PFD
		for(var i = 0; i < secArray.length; i++ ) {
			var pfdItem = secArray[i];
			let showSecProduct = pfdParentRecomAlso.querySelector(`[data-pfditem="${pfdItem}"]`);
			if (showSecProduct) {
				showSecProduct.classList.remove('hidden');
				showSecProduct.classList.add('show');
				pfdParentRecomAlso.classList.add('show');
				nothingFound = false;
			}
		}

		if (nothingFound == true) {
			pfdParentNoSelection.classList.add('show');
		}
	}

}


// Interactive DB
const toolDb = [
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26",
    "Secondary Choice": "Cirro 16"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Stratus 35",
    "Secondary Choice": "Atmos 40"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Arcus 40",
    "Secondary Choice": "Atmos 40"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Atmos 40",
    "Secondary Choice": "Stratus 35"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26",
    "Secondary Choice": "Cirro 16"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Stratus 35",
    "Secondary Choice": "Atmos 40"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Stratus 35",
    "Secondary Choice": "Atmos 40"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Atmos 40",
    "Secondary Choice": "Stratus 35"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Atmos 40",
    "Secondary Choice": "Stratus 35"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Atmos 40",
    "Secondary Choice": "Stratus 35"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Arcus 40",
    "Secondary Choice": "Atmos 40"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Arcus 40",
    "Secondary Choice": "Atmos 40"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Motive",
    "Secondary Choice": "Cirrus 26"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Motive",
    "Secondary Choice": "Stratus 35"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Kinetic",
    "Secondary Choice": "Atmos 40"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Stratus 35",
    "Secondary Choice": "Kinetic"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Cirrus 26"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26",
    "Secondary Choice": "Stratus 35"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Stratus 35",
    "Secondary Choice": "Cirrus 26"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Stratus 35",
    "Secondary Choice": "Cirrus 26"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Atmos 40",
    "Secondary Choice": "Stratus 35"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Atmos 40",
    "Secondary Choice": "Stratus 35"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Arcus 40",
    "Secondary Choice": "Atmos 40"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Arcus 40",
    "Secondary Choice": "Atmos 40"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Cirrus 26 - Tan"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26 - Tan",
    "Secondary Choice": "Drift"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Stratus 35 - Tan",
    "Secondary Choice": "Cirrus 26 - Tan"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Stratus 35 - Tan",
    "Secondary Choice": "Cirrus 26 - Tan"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26",
    "Secondary Choice": "Classic Foam"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26 Max5 Camo",
    "Secondary Choice": "Sportsman Foam Max5 Camo"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26 Max5 Camo",
    "Secondary Choice": "Sportsman Foam Max5 Camo"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26 Max5 Camo",
    "Secondary Choice": "Sportsman Foam Max5 Camo"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26 Max5 Camo",
    "Secondary Choice": "Sportsman Foam Max5 Camo"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirro 16",
    "Secondary Choice": "Drift"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirro 16",
    "Secondary Choice": "Cirrus 26 - Hi-Vis Green"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirrus 26 - Hi-Vis Green",
    "Secondary Choice": "Cirro 16"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Cirro 16",
    "Secondary Choice": "Cirrus 26 - Hi-Vis Green"
  },
  {
    "Activity": "Commercial Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Arcus 40",
    "Secondary Choice": "Cirrus 26"
  },
  {
    "Activity": "Commercial Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Arcus 40",
    "Secondary Choice": "Stratus 35"
  },
  {
    "Activity": "Commercial Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Arcus 40",
    "Secondary Choice": "Stratus 35"
  },
  {
    "Activity": "Commercial Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "16+ years",
    "Weight": "90 lbs +",
    "Primary Choice": "Arcus 40",
    "Secondary Choice": "Stratus 35"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Motive",
    "Secondary Choice": "Kinetic"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Kinetic",
    "Secondary Choice": "Motive"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Kinetic",
    "Secondary Choice": "Motive"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Classic Foam"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Kinetic"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Motive"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Kinetic"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Kinetic",
    "Secondary Choice": "Drift"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Kinetic"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Motive"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Motive",
    "Secondary Choice": "Drift"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Kinetic"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Motive",
    "Secondary Choice": "Drift"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Classic Foam",
    "Secondary Choice": "Sportsman Foam"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Sportsman Foam Max5 Camo",
    "Secondary Choice": "Classic Foam"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Sportsman Foam Max5 Camo",
    "Secondary Choice": "Classic Foam"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Sportsman Foam Max5 Camo",
    "Secondary Choice": "Classic Foam"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Sportsman Foam Max5 Camo",
    "Secondary Choice": "Classic Foam"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Drift",
    "Secondary Choice": "Motive"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Motive",
    "Secondary Choice": "Drift"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Kinetic",
    "Secondary Choice": "Motive"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "90 lbs +",
    "Primary Choice": "Kinetic",
    "Secondary Choice": "Motive"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Classic Foam - Youth",
    "Secondary Choice": "Sportsman Foam - Youth"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam Max5 Camo - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam Max5 Camo - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam Max5 Camo - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam Max5 Camo - Youth",
    "Secondary Choice": "Classic Foam - Youth"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth - Hi-Vis Green",
    "Secondary Choice": "Classic Foam - Youth - Optic Orange"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth - Hi-Vis Green",
    "Secondary Choice": "Classic Foam - Youth - Optic Orange"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth - Hi-Vis Green",
    "Secondary Choice": "Classic Foam - Youth - Optic Orange"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "50-90 lbs",
    "Primary Choice": "Sportsman Foam - Youth - Hi-Vis Green",
    "Secondary Choice": "Classic Foam - Youth - Optic Orange"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "General Boating",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Inland Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Deep-water Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Kayaking Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Day Sailing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Offshore Sailing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Casual Kayaking / Canoeing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Shore Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Water Fowl",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Small Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child - Optic Orange",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Large Body",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child - Optic Orange",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Ocean/Open Water",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child - Optic Orange",
    "Secondary Choice": "None"
  },
  {
    "Activity": "Stand Up Paddle Board Fishing",
    "Type of Water or Near Water Type": "Multiple Water Types",
    "Age": "3-15 years",
    "Weight": "30-50 lbs",
    "Primary Choice": "Classic Foam - Child - Optic Orange",
    "Secondary Choice": "None"
  }
];


   $( document ).ready(function() {
	   function autoAddtoCart() {
    //get the cart
    let cart = $.getJSON('/cart.js');
    // wait for the response
    cart.done(function(){
      //when you have the response, get the JSON and set items to cart.items
      cart = cart.responseJSON;
      let items = cart.items;
      // make a boolean to make sure that the item you want to add isnt already in the cart (to keep the JS from firing again on page reload)
      let item_in_cart_already = false;
// product we are checking to see is in the cart
      let atmosPFD = "4134551060514, 4353734377506, 4353735753762, 4353738244130, 4353740046370";
      let stratusPFD = "4829682237474, 4829679255586, 4829675782178, 4829668933666, 4829653270562, 4353800798242";
      let cirrusPFD = "4329978200098, 4355004694562, 4355006496802, 4355007709218, 4355009773602";

// the product we want to add's product id
      let atmosReArmID = 4378572324898;
      let cirrusReArmID = 4378570260514;
      let stratusReArmID = 4378570620962;
// the product we want to add's variant id
      let atmosReArm = 31337235513378;
      let cirrusReArm = 31337233448994;
      let stratusReArm = 31337233809442;

      let atmosRe_qty = 0;
      let stratusRe_qty = 0;
      let cirrusRe_qty = 0;

//check the cart items and set boolean to true if the item is in the cart
      for(var i = 0; i < items.length; i++){
        if (items[i].product_id == atmosReArmID){
          item_in_cart_already = true;
          atmosRe_qty = items[i].quantity;
        }
        if (items[i].product_id == stratusReArmID){
          item_in_cart_already = true;
          stratusRe_qty = items[i].quantity;
        }
        if (items[i].product_id == cirrusReArmID){
          item_in_cart_already = true;
          cirrusRe_qty = items[i].quantity;
        }


      }
      //then loop through cart items again and if the item isnt in the cart, and the corresponding product is found
      //add it to the cart with the same quantity as the other product.
//       if(!item_in_cart_already){
        let atmos_qty = 0;
        let stratus_qty = 0;
        let cirrus_qty = 0;

        for(var i = 0; i < items.length; i++){
          if (atmosPFD.indexOf(items[i].product_id) !== -1) {
            atmos_qty = atmos_qty + items[i].quantity;
          } else if (stratusPFD.indexOf(items[i].product_id) !== -1) {
            stratus_qty = stratus_qty + items[i].quantity;
          } else if (cirrusPFD.indexOf(items[i].product_id) !== -1) {
            cirrus_qty = cirrus_qty + items[i].quantity;
          }
        }

        if (atmos_qty > atmosRe_qty) {
          	atmos_qty = atmos_qty - atmosRe_qty;
            Shopify.addItem(atmosReArm, atmos_qty);
            setTimeout(function(){
              location.reload();
            },1000)
        } else {
        //   console.log("don't add atmos");
        }

        if (stratus_qty > stratusRe_qty) {
          	stratus_qty = stratus_qty - stratusRe_qty;
            Shopify.addItem(stratusReArm, stratus_qty);
            setTimeout(function(){
              location.reload();
            },1000)
        } else {
        //   console.log("don't add stratus");
        }

        if (cirrus_qty > cirrusRe_qty) {
          	cirrus_qty = cirrus_qty - cirrusRe_qty;
            Shopify.addItem(cirrusReArm, cirrus_qty);
            setTimeout(function(){
              location.reload();
            },1000)
        } else {
        //   console.log("don't add cirrus");
        //   console.log("cirrus_qty: " + cirrus_qty + " cirrusRe_qty: " + cirrusRe_qty);
        }
//       }
    })
}
   });

function removeItem(varID) {
  let variantId = varID;
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(variantId),
      quantity: 0,
    },
  }).then((data) => {
    cartBtn.textContent = "Add to cart";
    cartBtn.removeAttribute("data-variant-id");
  });
}